import { separateByThreeDigit } from '@/utilities/formatting';

export const formatCellData = (data?: number | null) => {
  if (data === undefined || data === null) {
    return 'n/a';
  }
  if (data === 0) return 0;
  return separateByThreeDigit(data, 0);
};
